import React, { useEffect, useRef, useState } from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FaFilePdf } from "react-icons/fa";
import $ from "jquery";
import "jquery-ui/dist/jquery-ui.js";
import "jquery-ui/themes/base/all.css";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function BoardApprovedCont() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const tableRef = useRef(null);

  const token = localStorage.getItem("token");
  const centcode = localStorage.getItem("CentCode");

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    const fetchData = async () => {

      try {
        setLoading(true);
        const response = await fetch(`${config.API_BASE_URL}/auth/BoardApprovalApproved`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            cenT_CODE: centcode,
          }),
        });

        if (response.status !== 200) {
          Swal.fire({
            icon: "warning",
            title: "Data not found!",
          });
          setLoading(false);
          setData([]);
          return;
        }

        const result = await response.json();
        const studentData = result?.data?.student_data ?? [];
        console.log(studentData);
        if (studentData.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "No Data Found",
            text: "No Approved board approvals available.",
          });
        }

        setData(studentData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        Swal.fire("Error", "Something went wrong!", "error");
        setLoading(false);
        setData([]); // Reset data on failure
      }
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    if (data.length > 0) {
      const table = $(tableRef.current).DataTable({
        paging: false,
        info: false,
        destroy: true,
        columnDefs: [{ orderable: false, targets: 0 }],
      });

      return () => {
        table.destroy();
      };
    }
  }, [data]);

  const movetodashboard = (e) => {
    e.preventDefault();
    navigate("/dashboard");
  };

  return (
    <div className="pc-container">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div className="pc-content">
        <div className="page-header">
          <div className="page-block">
            <div className="row align-items-center">
              <div className="col-md-12 breadcrumb">
                <div className="page-header-title">
                  <h5 className="m-b-10">APPROVED BY BOARD</h5>
                </div>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="" onClick={movetodashboard}>
                      Home
                    </a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="">APPROVED BY BOARD</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row" style={{ padding: "0px" }}>
          {data.length > 0 && (
            <div className="col-md-3" style={{ position: 'absolute', top: '100px', zIndex: '1', left: '33px' }}>
              <button
                className="btn btn-sm btn-success"
                onClick={() => window.open("/consolidated-list", "_blank")}
              >
                Open Consolidated List
              </button>
            </div>
          )}


          <div className="col-md-12">
            <div className="card tbl-card" style={{ border: "1px solid #1890ff" }}>
              <div className="card-body padding-10">
                <div className="table-responsive">
                  <table ref={tableRef} className="table table-hover table-bordered mb-0">
                    <thead>
                      <tr className="table-info">
                        <th className="text-start">Sl. No</th>
                        <th className="text-start">Exam Type</th>
                        <th className="text-start">Roll No</th>
                        <th>Name of Candidate</th>
                        <th>Gender</th>
                        <th>Father’s Name</th>
                        <th>Mother’s Name</th>
                        <th>Category</th>
                        <th className="text-start">Challan No</th>
                        <th>Payment Status</th>
                        <th>Board Approval Status</th>
                        <th>Board Approval Date & Time</th>

                      </tr>
                    </thead>
                    <tbody>
                      {data.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={index}>
                            <td className="text-start">{index + 1}</td>
                            <td className="text-start">{item.EXAM_TYPE || ""}</td>
                            <td className="text-start">{item.ROLL_NO}</td>
                            <td>
                              <i className="fa fa-user text-primary"></i>&nbsp;
                              {item.CAND_NAME}
                            </td>
                            <td>{item.GENDER_NAME}</td>
                            <td>{item.FATHERS_NAME}</td>
                            <td>{item.MOTHERS_NAME}</td>
                            <td>{item.CATEGORY_NAME}</td>
                            <td className="text-start">{item.CHALLAN_NO}</td>
                            <td>
                              {item.PAYMENT_STATUS === "Completed" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Completed</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Pending</span>
                              )}
                            </td>
                            <td>
                              {item.ADMIN_STATUS === "Approved" ? (
                                <span className="badge bg-light-success border border-success" style={{ fontSize: '12px' }}>Approved</span>
                              ) : (
                                <span className="badge bg-light-warning border border-warning" style={{ fontSize: '12px' }}>Pending</span>
                              )}
                            </td>
                            <td><b>{item.APPROVAL_DATE_TIME || ""}</b></td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default BoardApprovedCont;
